import { ProductConsumerAttributeDto } from '@yiluhub/yilu-amp-types';

import { ProductConsumerAttributeRequirement } from '../../utils';

/**
 * Define sort order for each traveller group (for better UX)
 */
const eurailFieldOrder = [
  'email',
  'phoneNumber',
  'title',
  'firstName',
  'lastName',
  'birthdate',
  'nationality',
];

/**
 * Extract traveller fields (adults, youths, seniors) in the expected order.
 */
export const getEurailFieldsToRender = (fields: ProductConsumerAttributeDto[]) => {
  // Only include mandatory visible fields
  const validFields = fields.filter((f) =>
    [ProductConsumerAttributeRequirement.MANDATORY].includes(
      f.requirement as ProductConsumerAttributeRequirement,
    ),
  );

  // Sort by group (adults, seniors, youths) and index (_1, _2...) and field order
  return validFields.sort((a, b) => {
    const [groupA, keyA, idxA] = parseEurailFieldParts(a.name);
    const [groupB, keyB, idxB] = parseEurailFieldParts(b.name);

    if (groupA !== groupB) return groupA.localeCompare(groupB);
    if (idxA !== idxB) return idxA - idxB;
    return eurailFieldOrder.indexOf(keyA) - eurailFieldOrder.indexOf(keyB);
  });
};

/**
 * Parse a Eurail field name like "adults_firstName_1" into parts.
 */
const parseEurailFieldParts = (name: string): [string, string, number] => {
  const regex = /(adults|seniors|youths)_(\w+)_(\d+)/;
  const match = regex.exec(name);
  if (!match) return ['', name, 0];

  const [, group, key, index] = match;
  return [group, key, Number(index)];
};
